import { GET_BATCH, GET_BATCH_DETAILS } from "../constants/Type";

const initialState = {
  batch: null,
  selected_batch: null,
  loading: true,
};

const batchReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_BATCH:
      return {
        ...state,
        batch: payload,
        loading: false,
      };
    case GET_BATCH_DETAILS:
      return {
        ...state,
        selected_batch: payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default batchReducer;
